export default "__VITE_ASSET__2eb6d211__"